import React, { FC } from "react";
import { Box, Button, Typography } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CloseIcon from "@mui/icons-material/Close";
import { colors, fontSize, radius, spacing } from "../styles/tokens";

interface GkvBulkActionToolbarProps {
  selectedCount: number;
  onDelete: () => void;
  onClear: () => void;
}

const GkvBulkActionToolbar: FC<GkvBulkActionToolbarProps> = ({
  selectedCount,
  onDelete,
  onClear,
}) => {
  if (selectedCount === 0) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 1.5,
        py: 0.75,
        mt: 0.75,
        backgroundColor: colors.cardBg,
        borderRadius: radius.md,
        border: `1px solid ${colors.borderLight}`,
      }}
    >
      <Typography
        sx={{
          fontSize: fontSize.data,
          fontWeight: 600,
          color: colors.textPrimary,
        }}
      >
        {selectedCount} {selectedCount === 1 ? "Rezept" : "Rezepte"} ausgewählt
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <Button
          size="small"
          startIcon={<CloseIcon sx={{ fontSize: 14 }} />}
          onClick={onClear}
          sx={{
            fontSize: fontSize.tag,
            fontWeight: 600,
            color: colors.textSecondary,
            textTransform: "none",
            px: 1,
            py: 0.25,
            minWidth: "auto",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.05)",
            },
          }}
        >
          Abbrechen
        </Button>
        <Button
          size="small"
          variant="contained"
          startIcon={<DeleteOutlineIcon sx={{ fontSize: 14 }} />}
          onClick={onDelete}
          sx={{
            fontSize: fontSize.tag,
            fontWeight: 600,
            textTransform: "none",
            px: 1.5,
            py: 0.25,
            minWidth: "auto",
            borderRadius: radius.sm,
            backgroundColor: colors.lightWarning,
            color: "#fff",
            boxShadow: "none",
            "&:hover": {
              backgroundColor: "#d4992e",
              boxShadow: "none",
            },
          }}
        >
          Löschen
        </Button>
      </Box>
    </Box>
  );
};

export default GkvBulkActionToolbar;
